import axios, { AxiosResponse } from 'axios';

import Constants from './Constants';
import { SharePointService } from './SharePointService';

export class AuthService {
  private static _sharePointService = SharePointService.Instance;

  public static async setExpirationTime() {
    const authSettings = await this._sharePointService.getAuthSettings();
    const now = new Date();
    const expirationTime =
      now.getTime() + authSettings.expirationTimeInMinutes * 60 * 1000;
    localStorage.setItem('expirationTime', expirationTime.toString());
  }

  public static checkExpiration() {
    const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true';
    if (isDevelopment) {
      return;
    }

    const expirationTime = localStorage.getItem('expirationTime');
    if (expirationTime) {
      const now = new Date().getTime();
      if (now > parseInt(expirationTime)) {
        window.location.href = Constants.LOGOUT_REDIRECT_URI;
      }
    }
  }

  public static removeExpirationTime() {
    localStorage.removeItem('expirationTime');
  }

  public static async getCurrentUserName(): Promise<string | null> {
    const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true';
    if (isDevelopment) {
      return 'Development User'; // For development purposes, return a static user name
    }

    try {
      const result: AxiosResponse<any> = await axios({
        method: 'get',
        url: `/.auth/me`,
        withCredentials: true,
      });

      if (result.data.length === 0 || result.data[0].user_claims.length === 0) {
        return null;
      }

      this.setExpirationTime();

      return result.data[0].user_claims.find(
        (claim: any) => claim.typ === 'name'
      )?.val;
    } catch (error) {
      console.error('Failed to get current user name', error);
      return null;
    }
  }
}
